const generateApiUrl = (endpoint: string) => `/api/v1/${endpoint}`;

//리프레시 토큰
export const TOKEN_REFRESH_URL = generateApiUrl("auth/token/reissue");

export const SIGN_IN_URL = generateApiUrl("auth/member/signin");
//회원가입
export const SIGN_UP_URL = generateApiUrl("member/signup");
// 탈퇴하기
export const DEACTIVATE_URL = generateApiUrl("member/deactivate");
//색상 리스트
export const GET_COLOR_URL = generateApiUrl("color");
//사이즈 리스트
export const GET_SIZE_URL = generateApiUrl("code/size");
//유저 정보
export const GET_USER_INFO_URL = generateApiUrl("member/me");
//파일 업로드
export const FILE_URL = generateApiUrl("file");
//컨디션 리스트
export const GET_CONDITION_URL = generateApiUrl("code/condition");
//카테고리 리스트
export const GET_CATEGORY_URL = generateApiUrl("code/category");
//상품 등록
export const POST_PRODUCT_URL = generateApiUrl("product");
// 상품 수정
export const PATCH_PRODUCT_URL = generateApiUrl("product");
//상품 상세정보
export const GET_PRODUCT_DETAIL_URL = generateApiUrl("product");
//상품 리스트
export const GET_PRODUCT_URL = generateApiUrl("product");
//브랜드 목록
export const GET_BRAND_URL = generateApiUrl("code/brand");
//브랜드 정렬 목록
export const BRAND_SORT_URL = generateApiUrl("code/brand-sort");
//팔로워, 팔로잉 리스트
export const GET_FOLLOW_URL = generateApiUrl("seller");
//브랜드
export const BRAND_URL = generateApiUrl("brand");
//셀러
export const SELLER_URL = generateApiUrl("seller");
//셀러 검색
export const SEARCH_SELLER_URL = generateApiUrl("search/seller");
//멤버
export const MEMBER_URL = generateApiUrl("member");
// We loves
export const WE_LOVES_URL = generateApiUrl("home/weLove");
// New In
export const NEW_IN_URL = generateApiUrl("home/newIn");
// Member Me
export const MemberMe_URL = generateApiUrl("member/me");
// Post Cart
export const POST_CART_URL = generateApiUrl("cart");
// Get Cart
export const GET_CART_URL = generateApiUrl("cart");
// Patch Cart
export const PATCH_CART_URL = generateApiUrl("cart");
// Delete Cart
export const DELETE_CART_URL = generateApiUrl("cart");

// 도매 브랜드 탐험
export const BRAND_EXPLORE = generateApiUrl("home/brand-explore");
// 로그인 팝업 이미지
export const POPUP_URL = generateApiUrl("home/popup");
// 홈 프로모션
export const PROMOTION_URL = generateApiUrl("home/promotion");
// FAQ 카테고리
export const GET_FAQ_CATEGORY_URL = generateApiUrl("code/faq-category");
// FAQ 리스트
export const GET_FAQ_LIST_URL = generateApiUrl("faq");
// NEWS 리스트
export const GET_NEWS_LIST_URL = generateApiUrl("news");
// NEWS 리스트
export const GET_ACTIVITY_ALARM_URL = generateApiUrl("notification");
// 홈 AD 리스트
export const AD_LIST_URL = generateApiUrl("home/advertisement");

// 홈 취향저격 셀러 리스트
export const GET_HOME_SELLER_LIST_URL = generateApiUrl("home/curated-seller");

// 구매 문의 리스트
export const PURCHASE_QNA_LIST = generateApiUrl("product/qna/purchase");
// 판매 문의 리스트
export const SALES_QNA_LIST = generateApiUrl("product/qna/sales");
// 상품 문의
// export const PRODUCT_QNA_LIST = generateApiUrl("product/");
export const CHECK_DUPLICATE_NICKNAME = generateApiUrl(
  "member/nickname/exists",
);

// 문의 답글 리스트
export const PRODUCT_QNA_LIST = generateApiUrl("product/qna");
//브랜드 검색 리스트
export const SEARCH_BRAND_LIST = generateApiUrl("search/brand");
//셀러 검색 리스트
export const SEARCH_SELLER_LIST = generateApiUrl("search/seller");

// 카카오 토큰
export const KAKAO_TOKEN_URL = "https://kauth.kakao.com/oauth/token";

// 카카오 로그인
export const POST_KAKAO_SIGNIN_URL = generateApiUrl("auth/kakao/signin");

// 애플 로그인
export const POST_APPLE_SIGNIN_URL = generateApiUrl("auth/apple/signin");

// 이메일 인증
export const EMAIL_VERIFICATION_URL = generateApiUrl(
  "member/verification-email/send",
);

// 비밀번호 찾기 이메일 인증
export const FIND_PASSWORD_EMAIL_VERIFICATION_URL = generateApiUrl(
  "member/password-reset-email/send",
);

// 비밀번호 찾가ㅣ submit
export const FIND_PASSWORD_URL = generateApiUrl("member/password/reset");

// 이메일 인증 get
export const GET_EMAIL_VERIFICATION_URL = generateApiUrl("member/email/verify");

// 비밀번호 찾기 이메일 인증
export const GET_FIND_PASSWORD_EMAIL_VERIFICATION_URL = generateApiUrl(
  "member/password-reset/verify",
);
// 성별 목록
export const GET_GENDER_LIST_URL = generateApiUrl("code/gender");

// 주문  post
export const POST_ORDER_URL = generateApiUrl("order");

// 주문 삭제
export const DELETE_ORDER_URL = generateApiUrl("order");

// 주문 리스트
export const GET_ORDER_LIST_URL = generateApiUrl("order");

// 주문 상세정보
export const GET_ORDER_DETAIL_URL = generateApiUrl("order");

// 주문 정렬 목록
export const GET_ORDER_SORT_LIST_URL = generateApiUrl("code/order-sort");

// 판매 정렬 목록
export const GET_SALES_SORT_LIST_URL = generateApiUrl("code/sales-sort");

// 판매 리스트
export const GET_SALES_LIST_URL = generateApiUrl("order/sales");

// 판매 상세정보
export const GET_SALES_DETAIL_URL = generateApiUrl("order");

// 결제수단 업데이트
export const UPDATE_ORDER_URL = generateApiUrl("order");

// 결제 승인 요청
export const CONFIRM_PAYMENT_URL = generateApiUrl("order");

// 주문 상태
export const GET_ORDER_STATUS_URL = generateApiUrl("order/order-seller");

// 주문 확정, 발송완료
export const CONFIRM_ORDER_URL = generateApiUrl("order");

// 리뷰
export const REVIEW_URL = generateApiUrl("review");

export const PRODUCT_DATA_FOR_REVIEW_URL = generateApiUrl("review");

//리뷰 작성 여부값
export const HAS_REVIEW_URL = generateApiUrl("review/order");

export const GET_RECEIVED_REVIEW_URL = generateApiUrl("review/seller");

// 상품 비활성화
export const UPDATE_PRODUCT_STATUS_URL = generateApiUrl("product");

// 상품 삭제
export const DELETE_PRODUCT_URL = generateApiUrl("product");

// 배송지 가져오기
export const GET_SHIPPING_ADDRESS = generateApiUrl("member/shipping");

// 베송지 수정
export const PATCH_SHIPPING_ADDRESS = generateApiUrl("member/shipping");
export const PRODUCT_POPUP_URL = generateApiUrl("product/popup");

//은행 목록
export const BANK_LIST_URL = generateApiUrl("code/bank");

// 구독 빌링 키 업데이트
export const UPDATE_BILLING_KEY_URL = generateApiUrl("member/billing-key");

// 구독 post
export const ADD_MEMBER_SUBSCRIPTION_URL = generateApiUrl(
  "member/subscription",
);

// 구독 취소
export const PATCH_MEMBER_SUBSCRIPTION_CANCEL_URL = generateApiUrl(
  "member/subscription/cancel",
);

// 구독 상태
export const GET_MEMBER_SUBSCRIPTION_STATUS = generateApiUrl(
  "member/subscription/status",
);

// 비밀번호 변경
export const PATCH_PASSWORD_URL = generateApiUrl("member/password");

// 상품 정렬
export const GET_PRODUCT_SORT_URL = generateApiUrl("code/product-sort");

// 알람 상태 업데이트
export const PATCH_NOTIFICATION_READ_STATUS_URL =
  generateApiUrl("notification");

// 상품 복사
export const COPY_PRODUCT_URL = generateApiUrl("product");

// 유저 알람 설정 상태
export const GET_NOTIFICATION_STATUS_URL = generateApiUrl(
  "notification/setting",
);

// 유저 알람 상태 업데이트
export const PATCH_NOTIFICATION_STATUS_URL = generateApiUrl(
  "notification/toggle",
);

// 이메일 체크
export const CHECK_EMAIL_URL = generateApiUrl("member/email");

// 구독 내역 리스트
export const SUBSCRIPTION_PAYMENT_LIST_URL = generateApiUrl(
  "member/subscription/payment",
);

// 상품 요율 조회
export const PRODUCT_CHARGE_RATE_URL = generateApiUrl("code/charge-rate");

// 이벤트
export const EVENT_URL = generateApiUrl("home/promotion");

export const COUNTRY_URL = generateApiUrl("code/country");

export const EXCHANGE_URL = generateApiUrl("exchange");

